import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Phone, Mail } from 'lucide-react';
import { companyInfo } from '../mock/data';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_polosi-railings/artifacts/68qhurhu_20260115_153628.jpeg"
          alt="AP Glass Railings Project"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/95 via-blue-900/90 to-slate-800/95"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-4xl">
          <div className="mb-6 inline-block">
            <span className="px-4 py-2 bg-blue-500/20 border border-blue-400/30 rounded-full text-blue-300 text-sm font-medium backdrop-blur-sm">
              {companyInfo.yearsOfExperience} Years of Excellence
            </span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold mb-4 text-white leading-tight">
            {companyInfo.name}
          </h1>
          
          <p className="text-xl md:text-2xl text-slate-300 mb-8 font-light">
            Premium Glass & Aluminum Railing Solutions
          </p>
          
          <p className="text-lg text-slate-400 mb-12 max-w-2xl">
            Serving the {companyInfo.location} with expert craftsmanship, stunning designs, and unmatched quality.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Button 
              size="lg" 
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
              onClick={() => scrollToSection('quote')}
            >
              Get Free Quote
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-2 border-slate-400 text-white hover:bg-white/10 px-8 py-6 text-lg transition-all duration-300 backdrop-blur-sm"
              onClick={() => scrollToSection('gallery')}
            >
              View Gallery
            </Button>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col sm:flex-row gap-6">
            <a 
              href={`tel:${companyInfo.phone}`}
              className="flex items-center gap-3 text-slate-300 hover:text-blue-400 transition-colors duration-300 group"
            >
              <div className="p-3 bg-blue-500/20 rounded-lg group-hover:bg-blue-500/30 transition-colors duration-300">
                <Phone className="h-5 w-5" />
              </div>
              <span className="text-lg font-medium">{companyInfo.phone}</span>
            </a>
            <a 
              href={`mailto:${companyInfo.email}`}
              className="flex items-center gap-3 text-slate-300 hover:text-blue-400 transition-colors duration-300 group"
            >
              <div className="p-3 bg-blue-500/20 rounded-lg group-hover:bg-blue-500/30 transition-colors duration-300">
                <Mail className="h-5 w-5" />
              </div>
              <span className="text-lg font-medium">{companyInfo.email}</span>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-slate-400 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-slate-400 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
